module.exports = __webpack_public_path__ + "static/media/prestashop-1-7.0b68c9e0.jpg";